/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Team_NameInputs */

const en_mk_price_team_name = /** @type {(inputs: Mk_Price_Team_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const id_mk_price_team_name = /** @type {(inputs: Mk_Price_Team_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {Mk_Price_Team_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_team_name = /** @type {((inputs?: Mk_Price_Team_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Team_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_team_name(inputs)
	return en_mk_price_team_name(inputs)
});